const FEATURES = [
  {
    id: 1,
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '流畅的竖屏下拉式浏览体验，无需翻页点击，手指滑动即可沉浸式阅读韩漫日漫国漫，还原手机端最佳漫画阅读感受。',
    color: 'text-primary-500',
    bg: 'bg-primary-50',
  },
  {
    id: 2,
    icon: 'ri-bookmark-line',
    title: '智能追更收藏',
    desc: '一键收藏喜欢的漫画作品，更新即时提醒。再也不用担心错过连载更新，追更从未如此简单高效。',
    color: 'text-accent-600',
    bg: 'bg-accent-50',
  },
  {
    id: 3,
    icon: 'ri-global-line',
    title: '三国漫画全集',
    desc: '覆盖韩漫、日漫、国漫三大品类，从经典全集到最新连载，超万部漫画资源持续扩充，满足不同口味的漫迷需求。',
    color: 'text-green-600',
    bg: 'bg-green-50',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '高清画质免费',
    desc: '全站漫画均提供高清画质，承诺永久免费阅读。无需会员充值，无隐藏收费，让每一位漫迷都能畅快看漫画。',
    color: 'text-amber-600',
    bg: 'bg-amber-50',
  },
  {
    id: 5,
    icon: 'ri-device-line',
    title: '多端同步阅读',
    desc: '支持电脑、平板、手机多端同步，阅读进度、收藏列表云端同步。随时随地切换设备，无缝继续精彩剧情。',
    color: 'text-rose-500',
    bg: 'bg-rose-50',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">平台优势</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            五大核心优势，为你打造极致漫画阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {FEATURES.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-200"
            >
              <div className={`w-11 h-11 ${feature.bg} rounded-xl flex items-center justify-center mb-4`}>
                <i className={`${feature.icon} text-xl ${feature.color}`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}